export default __webpack_public_path__ + "static/media/add_casenotes.bf757b37.svg";